import {useLoaderData} from "@remix-run/react";
import {Text} from "../../elements/text/index.js";
import {getGtagPageName} from "../../utils/getGtagPageName";
import * as gtag from "../../utils/gtag.client";
import {FilterButton, FilterWrapper, Wrapper} from "./styles.js";

export const Filters = ({
  type = "destination",
  sectionData,
  searchFilters,
  activeFilters,
  handleFilter,
}) => {
  const isSearch = type === "search";
  const data = useLoaderData();
  const showAllTranslation = data?.translation?.showAll || "Show all";
  const showAllFilter = {name: showAllTranslation, showAll: true};
  const filters = [
    showAllFilter,
    ...(Object.values(isSearch ? searchFilters : sectionData?.filters?.post_cat || {}) ||
      []),
  ];
  const region = sectionData?.filters?.dest_country?.[0]?.name;

  return (
    <Wrapper isSearch={isSearch}>
      {!!filters.length && (
        <FilterWrapper>
          {filters?.map((item, i) => {
            const filterValue = isSearch
              ? item?.term_taxonomy_id
              : `&fs[${item?.taxonomy}]=${item?.term_taxonomy_id}`;
            const isShowAllActive =
              item.showAll && activeFilters?.some((item) => item.showAll);

            const active = activeFilters.includes(filterValue) || isShowAllActive;
            return (
              <FilterButton
                key={i}
                onClick={() => {
                  const commonEventData = {
                    event: "menu",
                    selection: item.name,
                    action: "click",
                    page_name: getGtagPageName(window.location.pathname),
                  };

                  const eventData = isSearch
                    ? commonEventData
                    : {...commonEventData, region};

                  gtag.event(eventData);

                  if (isShowAllActive) {
                    return handleFilter([showAllFilter]);
                  }
                  if (activeFilters.includes(filterValue)) {
                    return;
                  }
                  handleFilter([item?.showAll ? showAllFilter : filterValue]);
                }}
                active={active}
              >
                <Text
                  style={{
                    color: active ? "white" : "#1D3140",
                    transform: "skew(+12deg)",
                  }}
                  type={"bodyRegular"}
                >
                  {item.name}
                </Text>
              </FilterButton>
            );
          })}
        </FilterWrapper>
      )}
    </Wrapper>
  );
};
